module.exports = __webpack_public_path__ + "static/freedom-on-wheels-3494aed80cc86d484b0032c39521d020.jpg";